/**
 * Copyright (c) 2018-present, Didi, Inc.
 * All rights reserved.
 *
 * @author Cory(kuanghongrui@didichuxing.com)
 *
 * @file The class of TestingByUrlH5EnvConfig
 */

import { IEnvConfigurationItemAsync } from 'com/didichuxing/tracker/config/IEnvConfigurationItemAsync';
import { ITrackerContext } from 'com/didichuxing/tracker/context/ITrackerContext';
import { ITracker } from 'com/didichuxing/tracker/ITracker';
import GlobalUtil from 'com/didichuxing/tracker/plugin/utils/GlobalUtil';

const DEBUG_KEY: string = '__OMG_DBG';

/**
 * 端内H5环境配置
 *
 * @class
 * @implements {IEnvConfigurationItem}
 */
export default class TestingByUrlH5EnvConfig implements IEnvConfigurationItemAsync {

    /**
     * @constructor
     */
    constructor() {
        this.beforeunloadHandler = this.beforeunloadHandler.bind(this);
    }

    /**
     * window.OmegaSDK存在，则说明在端内。
     * @override
     * @inheritDoc
     * @param {ITrackerContext} context
     * @returns {boolean}
     */
    public validate(context: ITrackerContext): boolean {
        return /omgh5dbg=1/.test(document.location.search) || new RegExp(`${ DEBUG_KEY }=true`).test(document.cookie);
    }

    /**
     * @override
     * @inheritDoc
     * @param {ITracker} tracker
     * @returns {Promise<void>}
     */
    public beforeDeliver(tracker: ITracker): Promise<void> {
        if (/omgh5dbg=1/.test(document.location.search)) {
            const expiredDate: Date = new Date();
            expiredDate.setFullYear(expiredDate.getFullYear() + 10);
            document.cookie = `${ DEBUG_KEY }=true; expires=${ expiredDate }; path=/`;
        }
        window.addEventListener('beforeunload', this.beforeunloadHandler);
        return Promise.resolve();
    }

    /**
     * 关闭浏览器时执行
     */
    private beforeunloadHandler(): void {
        window.removeEventListener('beforeunload', this.beforeunloadHandler);
        document.cookie = `${ DEBUG_KEY }=; expires=-1; path=/`;
    }

    /**
     * @override
     * @inheritDoc
     * @returns {string}
     */
    public getPluginsUrl(): string {
        return GlobalUtil.getProtocol() + '{{cdnHost}}/static/{{cdnNamespace}}/{{version}}/omega.plugins.testing.url.min.js';
    }
}
